module.exports = __webpack_public_path__ + "static/img/1.44c6cc6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/1.png
// module id = dyhG
// module chunks = 0